/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import Vue from 'vue'
import store from '@src/store'
import i18n from '@/i18n'
import App from '@src/App.vue'
import router from './router'

interface ParamsInfo {
  companyId?: string | number
  userId?: string | number
  groupId?: string | number
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  create_team?: string
  inviteLink?: string
  code?: string
}

interface MainModuleParams {
  mountElId: string
  targetPage?: string
  targetData?: object
  isMobile?: boolean
  paramsInfo?: ParamsInfo
  customFlow?: boolean
}

class MainModule {
  private options: MainModuleParams | undefined
  constructor() {
    // this.init(options)
    window.$regPlatformInfo = {}
  }

  #subscribers = {
    onBeforeMount: () => {},
    onAfterMount: () => {},
    onSuccess: params => {},
    onFail: () => {},
  }

  // 设置companyId
  set companyId(val) {
    window.$regPlatformInfo = {
      ...(window.$regPlatformInfo || {}),
      companyId: val,
    }
  }

  // 设置userId
  set userId(val) {
    window.$regPlatformInfo = {
      ...(window.$regPlatformInfo || {}),
      userId: val,
    }
  }

  #vueInstantiation?: any

  #onVueInstantiation() {
    const _vue = new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
    })

    return _vue
  }

  #destroyVue(mountElId) {
    const registerApp = document.querySelector('#register-app')
    if (registerApp) {
      registerApp.innerHTML = ''
      registerApp.id = mountElId.slice(1)
    }
  }

  init(params: MainModuleParams) {
    this.options = params
    const {
      isMobile = false,
      targetData,
      targetPage,
      mountElId,
      paramsInfo,
      customFlow,
    } = params
    this.#vueInstantiation = this.#onVueInstantiation()
    const regPlatformTargetPage =
      targetPage || (isMobile ? 'UnifiedRegisterMobile' : 'SignUp')
    window.$regPlatformTargetPolicyData = targetData
    window.$nextProcess = payload => this.nextProcess.call(this, payload)
    window.$regPlatformTargetPage = regPlatformTargetPage
    window.$regPlatformTargetPolicyData = targetData
    window.$regPlatformInfo = {
      ...Vue.prototype.$regPlatformInfo,
      ...(paramsInfo || {}),
    }
    window.$regPlatformCustomFlow = customFlow || false
    this.#subscribers.onBeforeMount()
    this.#vueInstantiation.$mount(mountElId)
    this.#subscribers.onAfterMount()

    window.$regPlatformSuccess = payload =>
      this.#subscribers.onSuccess.call(this, {
        ...payload,
        targetPage: regPlatformTargetPage,
      })

    window.$regPlatformFail = () => this.#subscribers.onFail.call(this)
  }

  nextProcess(params: MainModuleParams) {
    const { mountElId, paramsInfo } = { ...this.options, ...params }
    this.#vueInstantiation?.$destroy() // 销毁上一次实例
    this.#destroyVue(mountElId)
    this.init({ ...this.options, ...params })

    window.$regPlatformInfo = {
      ...window.$regPlatformInfo,
      ...paramsInfo,
    }
  }

  destroy() {
    this.#vueInstantiation?.$destroy() // 销毁上一次实例
    this.#destroyVue(this.options?.mountElId)
  }

  // 订阅事件
  onSubscibeEvent(
    eventName: 'onBeforeMount' | 'onAfterMount' | 'onSuccess' | 'onFail',
    callbackFunction: () => void
  ) {
    if (this.#subscribers[eventName]) {
      this.#subscribers[eventName] = callbackFunction
    }
  }
}

export default MainModule
